<template>
  <div class="MeineKartenContainer">
    <div class="profilOption borderBlue colorBlue" @click="setKartenansicht" v-if="!kartenansicht" style="margin-top:50px;">
      <div class="profileOptionTextImage">
        <SVGIcon name="kartenausschnitt"  />
        <div class="profilOptionText">Kartenansicht merken</div>
      </div>
    </div>
    <div class="kartenansicht displayflex borderGrey flexbetween colorBlue fontweight600" v-else>
      <div class="displayflex">
        <SVGIcon name="kartenausschnitt_saved" />
        <div class="selfAlignCenter marginleft15">Meine Kartenansicht</div>
      </div>
      <div class="selfAlignCenter">
        <div class="displayflex flexnowrap" style="height:36px">
          <SVGIcon name="trash_blue" class="cursor-pointer" @click.native="deleteKartenansicht"/>
          <SVGIcon name="edit_blue" class="cursor-pointer marginleft15" @click.native="setKartenansicht"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MeineKarten',
  methods: {
    setKartenansicht () {
      this.setKartenMode({ mode: 'Kartenansicht_anlegen' })
      this.$emit('closeSidebar')
    },
    setKartenMode (mode) {
      this.$store.commit('setKartenMode', mode)
    },
    deleteKartenansicht () {
      this.$store.dispatch('deleteKartenansicht')
    }
  },
  computed: {
    kartenansicht () {
      return this.$store.state.kartenansicht
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.MeineKartenContainer {
  height: 100%;
  width: 100%;
}

.profilOption {
  border-width: 1px;
  border-style: solid;
  border-radius: 50px;
  padding: 10px;
  margin-bottom: 30px;
  cursor: pointer;
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.profilOptionText {
  margin-left: 15px;
  display: flex;
  flex-direction: column;
  align-self: center;
}
.profileOptionTextImage {
  display: flex;
  white-space: nowrap;
}

.kartenansicht {
  width: 100%;
  padding: 20px 0;
  border-bottom-style: solid;
  border-bottom-width: 1px;
}
</style>
